import myAxios from "@/utils/request";
export default {
  getApplyList(params) {
    return myAxios.post("/api/matchconsult/backselet", params);
  },
  batchApplyDelete(params) {
    return myAxios.post("/api/matchconsult/batchdelete", params);
  },
  // 专题赛通知公告
  getNoticeList(params) {
    return myAxios.post("/api/comnotice/backselet", params);
  },
  batchNoticeDelete(params) {
    return myAxios.post("/api/comnotice/batchdelete", params);
  },
  addNotice(params) {
    return myAxios.post("/api/comnotice/addorupdate", params);
  },
  getNoticeInfo(params) {
    const { id } = params;
    return myAxios.get("/api/comnotice/getinfo?id=" + id);
  },
  // 专题赛活动
  getActivityList(params) {
    return myAxios.post("/api/comactivity/backselet", params);
  },
  batchActivityDelete(params) {
    return myAxios.post("/api/comactivity/batchdelete", params);
  },
  addActivity(params) {
    return myAxios.post("/api/comactivity/addorupdate", params);
  },
  getActivityInfo(params) {
    const { id } = params;
    return myAxios.get("/api/comactivity/getinfo?id=" + id);
  },
  // 专题赛需求
  getDemandList(params) {
    return myAxios.post("/api/ztsrequirement/getztsrequirementlist", params);
  },
  batchDemandDelete(params) {
    return myAxios.post("/api/ztsrequirement/backbatchdelete", params);
  },
  addDem(params) {
    return myAxios.post("/api/ztsrequirement/addoreditztsrequirement", params);
  },
  getDemInfo(params) {
    const { id } = params;
    return myAxios.get("/api/ztsrequirement/getdetailbyid?id=" + id);
  },
  // 专题赛企业服务
  getServiceList(params) {
    return myAxios.post("/api/companydemand/backselet", params);
  },
  batchServiceDelete(params) {
    return myAxios.post("/api/companydemand/batchdelete", params);
  },
  // 专题赛企业解决方案
  getSolutionList(params) {
    return myAxios.post("/api/ztssolution/getbackpaing", params);
  },
  batchSolutionDelete(params) {
    return myAxios.post("/api/ztssolution/batchdelete", params);
  },
  addSolution(params) {
    return myAxios.post("/api/ztssolution/topaddztssolution_im", params);
  },
  getSolutionInfo(params) {
    const { id } = params;
    return myAxios.get("/api/ztssolution/getdetailbyid_im?id=" + id);
  }
};
